import { Injectable } from '@angular/core';
import { toLower } from 'lodash';

/**
 * Validation Service
 */
@Injectable()
export class ValidationService {
  /**
   * Check whether the value is alphanumeric or not
   *
   * @param value
   */
  validatingAlphaNumeric(value: string) {
    const re = /((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+[0-9a-z]+$/i;
    return re.test(value);
  }

  /**
   * Check whether the value only contains alphanumeric and spaces
   *
   * @param value
   */
  validatingAlphabetsAndSpace(value: string) {
    const re = /^[a-zA-Z\s]*$/;
    return re.test(value);
  }

  /**
   * Check whether the values only contains alphabets
   *
   * @param value
   */
  validatingAlphabets(value: string) {
    const re = /^[a-zA-Z]*$/;
    return re.test(value);
  }

  /**
   * Validting phone number format (000) 000-0000
   *
   * @param value
   */
  validatingPhoneNumber(value: string) {
    const re = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/;
    if (value) {
      return !re.test(String(value));
    }
    return true;
  }

  /**
   * Validting email address
   *
   * @param value
   */
  validatingEmail(value: string) {
    // tslint:disable-next-line: max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value) {
      return !re.test(String(value));
    }
    return true;
  }

  isAlSupportEmail(email: string) {
    const supportUserEmailExpression = /^alsupport\.[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@autoleap\.com$/;
    return !!(email && supportUserEmailExpression.test(toLower(email)));
  }

  validateEmail(email: string) {
    // tslint:disable-next-line: max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return new RegExp(re).test(email);
  }

  /**
   * Validating CSV file type
   *
   * @param file
   * @param type
   */
  validatFileTypeCsv(file: any, type: any) {
    const docs = ['docx', 'xlsx', 'doc', 'pdf', 'csv', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', ''];
    const img = ['jpg', 'jpeg', 'gif', 'png'];
    let allowed;
    let isAllowed = false;
    type === 'doc' ? (allowed = docs) : (allowed = img);
    const fileType = file[0].name.split('.');
    if (fileType.length > 1) {
      allowed.indexOf(fileType[1].toLowerCase()) !== -1 ? (isAllowed = true) : (isAllowed = false);
    } else {
      allowed.indexOf(fileType[0]) !== -1 ? (isAllowed = true) : (isAllowed = false);
    }
    return isAllowed;
  }

  /**
   * Formatting zip code
   *
   * @param value
   */
  formatZip(value) {
    const formattedZip = this.validatingAlphaNumeric(value) === true ? `${value.substring(0, 3)} ${value.substring(3, 6)}` : value;
    return formattedZip.toUpperCase();
  }

  /**
   * Validate webstes
   *
   * @param website website to validate return true if website is valid
   */
  validateWebsite(website: string): boolean {
    // tslint:disable-next-line: max-line-length
    const websiteRegex = /(^http[s]?:\/{2})|(^www)|(^\/{1,2})$/;
    return websiteRegex.test(website);
  }

  validateSiteProtocol(url: string) {
    const protocolCheck = /(http(s?)):\/\//i;
    return protocolCheck.test(url);
  }

  /**
 * Validate URL
 *
 * @param URL website to validate return true if website is valid
 */
  validateURLWebsite(website: string): boolean {
    const websiteRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    return websiteRegex.test(website);
  }


  onlyNumberKey(event) {
    const charCode = event.which ? event.which : event.keyCode;
    return charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57) ? false : true;
  }

  enterOnlyGreaterNumber(event: any, minValue) {
    return parseFloat(minValue) < parseFloat(event.target.value) ? true : false;
  }

  validatePhoneNumberDigits(str: string) {
    const re = /\d{10}$/;
    return new RegExp(re).test(str);
  }

  validateVIN(str: string) {
    const re = /[a-zA-Z0-9]{17,17}/;
    return new RegExp(re).test(str);
  }

  validateCustomFleetSettings(fleetSettings: any, errors: any) {
    let isValid = true;

    const {
      isOrderDiscOverride,
      isShopSuppliesOverride,
      isLaborRateOverride,
      isPricingMatrixOverride,
      isTaxCodeOverride,
      customLaborRate,
      customTaxCode,
      customPartPricingMatrix,
      customShopSuppliesType,
      customShopSuppliesValue,
      customShopSuppliesCap,
      customOrderDiscountType,
      customOrderDiscountValue,
      customOrderDiscountCap,
    } = fleetSettings;
    if (isOrderDiscOverride) {
    }

    if (isShopSuppliesOverride) {
      if (!customShopSuppliesType) {
        errors.customShopSuppliesType = 'Calculation type is required';
        isValid = false;
      }

      if (!customShopSuppliesValue) {
        errors.customShopSuppliesValue = 'Shop fees is required';
        isValid = false;
      }

      if (customShopSuppliesType && customShopSuppliesType.value === 'percentage' && !customShopSuppliesCap) {
        errors.customShopSuppliesCap = 'Max fees is required';
        isValid = false;
      }
    } else {
      errors.customShopSuppliesType = '';
      errors.customShopSuppliesValue = '';
      errors.customShopSuppliesCap = '';
    }

    if (isOrderDiscOverride) {
      if (!customOrderDiscountType) {
        errors.customOrderDiscountType = 'Calculation type is required';
        isValid = false;
      }

      if (!customOrderDiscountValue) {
        errors.customOrderDiscountValue = 'Discount is required';
        isValid = false;
      }

      if (customOrderDiscountType && customOrderDiscountType.value === 'percentage' && !customOrderDiscountCap) {
        errors.customOrderDiscountCap = 'Max discount is required';
        isValid = false;
      }
    } else {
      errors.customOrderDiscountType = '';
      errors.customOrderDiscountValue = '';
      errors.customOrderDiscountCap = '';
    }

    if (isLaborRateOverride) {
      if (!customLaborRate || (customLaborRate && !customLaborRate._id)) {
        errors.customLaborRate = 'Labor rate is required';
        isValid = false;
      }
    } else {
      errors.customLaborRate = '';
    }

    if (isTaxCodeOverride) {
      if (!customTaxCode || (customTaxCode && !customTaxCode._id)) {
        errors.customTaxCode = 'Tax code is required';
        isValid = false;
      }
    } else {
      errors.customTaxCode = '';
    }

    if (isPricingMatrixOverride) {
      if (!customPartPricingMatrix || (customPartPricingMatrix && !customPartPricingMatrix._id)) {
        errors.customPartPricingMatrix = 'Part pricing matrix is required';
        isValid = false;
      }
    } else {
      errors.customPartPricingMatrix = '';
    }

    return isValid;
  };

  validationMyFleetFields(fields, requirements = []) {


    // Only map fields where requiredFlag is true
    const fieldMap = {
      "Drivers Company Name": "companyName",
      "Work Authorization Number": "authorizeNumber",
      "Fleet ID Number": "fleetNumber",
      "Fleet Service Card #": "serviceCardNumber",
      "Purchase Order Number": "poNumber",
      "Fleet Driver Name": "fullName",
      "Vehicles Mileage": "mileage",
      "Vehicle Unit Number": "unitNumber",
      "License Plate Number": "licensePlateNo",
      "VIN": "vin",
      "Vehicle Model": "model",
      "Vehicle Year": "year"
    };
   
    // Reduce through the requirements array and validate only the required fields
    const showValidation = requirements.reduce((acc, req) => {
      const fieldKey = fieldMap[req.display];
      // Only process if the requiredFlag is true and the field is empty
      if (req.requiredFlag && !fields[fieldKey] && fieldKey) {
        acc[fieldKey] = true;
      }
      return acc;
    }, {});

    // Reduce through the requirements array and validate only the required fields
    const requiredFields = requirements.reduce((acc, req) => {
      const fieldKey = fieldMap[req.display];

      // Only process if the requiredFlag is true and the field is empty
      if (req.requiredFlag && fieldKey) {
        acc[fieldKey] = true;
      }

      return acc;
    }, {});

    return { showValidation, requiredFields };
  }

}
